import { render, staticRenderFns } from "./RatingsEdit.html?vue&type=template&id=2e57b492&external"
import script from "./RatingsEdit.ts?vue&type=script&lang=ts&external"
export * from "./RatingsEdit.ts?vue&type=script&lang=ts&external"
import style0 from "./RatingsEdit.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports